module.exports = __webpack_public_path__ + "img/logo.04e1ed49.png";